import {styled} from "@mui/material/styles"
import {FALLBACK_FONT_FAMILY, breakpoints} from "@next/ux-fabric"
import {Button as MUIButton, Link, Drawer as MUIDrawer, Typography, Grid} from "@mui/material"
import {COUNTRY_SELECTOR_DRAWER_BREAKPOINT} from "../../../../config/constants"

export const InnerContainer = styled("div")`
    margin: 0 1rem 1rem 1rem;
    width: 100%;
`

export const CountrySelectorContainer = styled("div")`
    align-items: center;
    display: flex;
    flex-direction: column;
    background: ${({theme}) => `${theme.uxfabric.background.paper}`};
    width: 100%;
`

export const Title = styled(Typography)`
    display: flex;
    height: 2.75rem;
    width: 100%;
    color: ${({theme}) => `${theme.uxfabric.text.primary}`};
    justify-content: center;
    align-items: center;
    font-family: ${({theme}) => theme.uxfabric.global.subtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY} !important;
`

export const CountrySelectorCTAWrapper = styled("div")`
    && {
        width: 100%;
        height: 2.75rem;
        font-family: ${({theme}) =>
            `${theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
        font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
        font-size: ${({theme}) => theme.uxfabric.component.buttonMedium.fontSize};
        line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};
        text-transform: ${({theme}) => theme.uxfabric.component.buttonMedium.textTransform};
        letter-spacing: ${({theme}) => theme.uxfabric.component.buttonMedium.letterSpacing}px;
        border-radius: ${({theme}) => theme.uxfabric.shape.global.button.medium.borderRadius};

        @media (min-width: ${breakpoints.values.md}px) {
            width: 8.625rem;
            margin-left: 1rem;
            height: 2.25rem;
        }
        span {
            line-height: ${({theme}) => theme.uxfabric.component.buttonMedium.lineHeight};
        }
        button {
            font-family: ${({theme}) =>
                `${theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
            font-weight: ${({theme}) => theme.uxfabric.component.buttonMedium.fontWeight};
        }
    }
`

export const CloseButton = styled(MUIButton)`
    && {
        position: absolute;
        top: 1rem;
        right: 1rem;
        padding: 0;
        justify-content: flex-end;
        @media (min-width: ${breakpoints.values.md}px) {
            justify-content: flex-start;
        }
        background: ${({theme}) => `${theme.uxfabric.background.paper}`};
        width: 0.75rem;
        height: 0.75rem;
        min-width: 0.75rem;
        border-radius: 0;
        border: 0;

        &:hover,
        &:active {
            background: ${({theme}) => `${theme.uxfabric.background.paper}`};
            border: 0;
        }

        &:focus {
            border: 0;
            border-radius: 0;
        }
    }
`

export const LanguageButtonsContainer = styled("div")`
    display: flex;
    justify-content: center;
    margin: 0 0 1.25rem 0;
    width: 100%;
    @media (min-width: ${breakpoints.values.md}px) {
        margin: 0;
        padding-left: 1rem;
        width: unset;
    }
    & > button:nth-of-type(2) {
        margin-left: 0.75rem;
    }
`

export const LanguageButton = styled("button")<{selected: boolean}>`
    height: 2.75rem;
    width: 100%;

    border: ${({selected}) => (selected ? "2px solid" : "1px solid")};
    border-color: ${({theme, selected}) =>
        selected
            ? theme.uxfabric.components.toggleButton.selected.default.borderColor
            : theme.uxfabric.action.default.enabled.borderColor};
    background: ${({theme, selected}) =>
        selected
            ? theme.uxfabric.components.toggleButton.selected.default.backgroundColor
            : theme.uxfabric.action.default.enabled.backgroundColor};
    color: ${({theme}) => `${theme.uxfabric.text.primary}`};

    font-family: ${({theme}) =>
        `${theme.uxfabric.component.buttonMedium.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-weight: ${({theme}) => `${theme.uxfabric.component.buttonMedium.fontWeight}`};
    font-size: ${({theme}) => `${theme.uxfabric.component.buttonMedium.fontSize}`};
    text-transform: ${({theme}) => `${theme.uxfabric.component.buttonMedium.textTransform}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.component.buttonMedium.letterSpacing}px`};
    border-radius: ${({theme}) => theme.uxfabric.shape.global.toggleButton.large.borderRadius};

    padding: 0.563rem 1rem;
    cursor: pointer;
    &:focus {
        outline: none;
    }
    @media (min-width: ${breakpoints.values.md}px) {
        width: unset;
        height: 2.25rem;
        border-radius: ${({theme}) => theme.uxfabric.shape.global.toggleButton.medium.borderRadius};
    }
`

export const CountrySelectorContainerElement = styled("div")`
    width: 100%;
    margin: 1rem 0;
    @media (min-width: ${breakpoints.values.md}px) {
        margin: 0;
        width: unset;
    }
    display: flex;
    flex-direction: column;
`

export const CountrySelectorROWText = styled(Typography)`
    color: ${({theme}) => `${theme.uxfabric.text.primary}`};
    font-family: ${({theme}) => `${theme.uxfabric.global.body1.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
`

export const CountrySelectorROW = styled("div")`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0 0;
    line-height: 1.5rem;
`
export const ViewAllLink = styled(Link)`
    color: ${({theme}) => `${theme.uxfabric.components.link.primary.enabled.textColor}`};
    text-decoration: underline;
    &:visited,
    &:active,
    &:hover,
    &:focus,
    &:active,
    &:hover,
    &:focus,
    &:visited {
        color: ${({theme}) => `${theme.uxfabric.components.link.primary.enabled.textColor}`};
    }
    font-family: ${({theme}) => `${theme.uxfabric.global.body3.fontFamily}, ${FALLBACK_FONT_FAMILY}`} !important;
    font-size: ${({theme}) => `${theme.uxfabric.global.body3.fontSize}`};
    font-weight: ${({theme}) => `${theme.uxfabric.global.body3.fontWeight}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.global.body3.letterSpacing}`};
    text-transform: ${({theme}) => `${theme.uxfabric.global.body3.textTransform}`};
`
export const DrawerContainer = styled(MUIDrawer)`
    position: initial;
    && > div:first-of-type {
        background: ${({theme}) => theme.uxfabric.components.backdrop.default.backgroundColor};
    }

    && > div:nth-of-type(3) {
        overflow-y: initial;
        width: 100%;
        @media (min-width: ${COUNTRY_SELECTOR_DRAWER_BREAKPOINT}) {
            overflow-y: auto;
            width: 100%;
        }
    }
`

export const StyledGrid = styled(Grid)`
    flex-direction: column;
    padding: 0 1rem;

    @media (min-width: ${breakpoints.values.md}px) {
        flex-direction: row;
        padding: 0;
    }
`
